// extracted by mini-css-extract-plugin
export var actions = "_3s-0";
export var actionsContainer = "_3s-5";
export var border = "_3s-1";
export var childFullHeight = "_3s-c";
export var collapse = "_3s-2";
export var content = "_3s-7";
export var contentChild = "_3s-b";
export var fullscreen = "_3s-9";
export var headerContainer = "_3s-3";
export var hidePadding = "_3s-8";
export var noScrollX = "_3s-d";
export var noScrollY = "_3s-e";
export var optOutTopPadding = "_3s-a";
export var pagePadding = "_3s-6";
export var profile = "_3s-f";
export var profileContainer = "_3s-g";
export var profileImage = "_3s-h";
export var profileMain = "_3s-i";
export var profileSubtitle = "_3s-k";
export var profileTitle = "_3s-j";
export var tabsWrapper = "_3s-4";
export var title = "_3s-l";